// isContractCall call narrows a call type based on the presence of abi
// this is okay, because when abi is defined, call type is narrowed to ContractCall
export function isContractCall(call) {
    return call.abi != null;
}
//# sourceMappingURL=order.js.map